import { ImagePlus } from "lucide-react";

const PlaceholderImage = ({ label, ratio = "aspect-[4/3]", testId }) => (
  <div
    data-testid={testId}
    className={`${ratio} w-full bg-slate-50 border-b border-dashed border-slate-300 flex flex-col items-center justify-center gap-2 text-slate-400 select-none`}
  >
    <ImagePlus size={22} strokeWidth={1.5} />
    <span className="text-xs font-medium">{label}</span>
    <span className="text-[10px] text-slate-400">Photograph to be supplied</span>
  </div>
);

export default PlaceholderImage;
